<style scoped>
#search_results {
	padding: 5px;
	padding-top: 10px;
}

.column_heading {
	font-size: 16px;
	font-weight: bold;
}
</style>

<template>
	<div id="search_results">
		<v-alert type="error" v-if="errormsg != ''">{{
			errormsg
		}}</v-alert>

		<div v-if="!loading">

			<div v-if="task_count == 0" class="px-2">
				<span>There are no tasks that match your selection</span>
			</div>

			<v-row v_if="(group_mode == 0)">
				<v-col 
					cols="12" sm="6" md="4" lg="3" xl="2"
					v-for="task in filtered_tasks('')"
					v-bind:key="task.id"
				>
					<task_item
						:task="task"
						@click="task_id => open_task(task_id)"
						@stop_recording="stop_recording()"
					/>
				</v-col>
			</v-row>

			<v-row v_if="(group_mode != 0)">
				<v-col cols="12" sm="6" md="4" lg="3" xl="2" v-for="group in groups" v-bind:key="group.key">
					<div class="group_desc">{{ group.desc }}</div>
					<task_item
						v-for="task in filtered_tasks(group.key)" 
						v-bind:key="task.id"
						:task="task"
						@click="open_task(task.id)"
						@stop_recording="stop_recording()"
					/>
				</v-col>
			</v-row>

		</div>

		<div v-if="loading">
			<v-skeleton-loader
				type="list-item-avatar-two-line"
				width="100%"
			></v-skeleton-loader>
			<v-skeleton-loader
				type="list-item-avatar-two-line"
				width="100%"
			></v-skeleton-loader>				
		</div>
	</div>
</template>

<script>
import task_item from "@/components/tasks/task_item";
import moment from 'moment';

export default {
	data() {
		return {
			loading: false,
			iteration: 1,
			errormsg: '',
			search: {
				name: "",
				assign_mode: 0,
				date_mode: 1,
				start_date: '',
				end_date: '',
				group_mode: 0
			},
			tasks: [],
		}
	},
	computed: {
		group_mode: function() {
			return this.search.group_mode;
		},
		groups: function() {
			let groups = [];
			
			if (this.search.group_mode == 1) {
				/* group by date */
				this.tasks.forEach(function(task) {
					let group = {
						key: task.date_fmt,
						desc: task.date_fmt,
						sortval: task.date
					};

					if (!groups.find(g => g.key == group.key)) {
						groups.push(group);
					}

				});
			} else if (this.search.group_mode == 2) {
				/* group by client */
				this.tasks.forEach(function(task) {
					let group = {
						key: task.client.id,
						desc: task.client.code + ": " + task.client.name,
						sortval: task.client.code
					};

					if (!groups.find(g => g.key == group.key)) {
						groups.push(group);
					}

				});
			} else if (this.search.group_mode == 3) {
				/* group by job */
				this.tasks.forEach(function(task) {
					let group = {
						key: task.job.id,
						desc: task.job.code + ": " + task.job.name,
						sortval: task.job.code
					};

					if (!groups.find(g => g.key == group.key)) {
						groups.push(group);
					}

				});
			} else if (this.search.group_mode == 4) {
				/* group by status */
				this.tasks.forEach(function(task) {
					let group = {
						key: task.status.id,
						desc: task.status.desc,
						sortval: task.status.type + ' ' + task.status.desc.toUpperCase()
					};

					if (!groups.find(g => g.key == group.key)) {
						groups.push(group);
					}

				});
			}

			groups.sort(function(a, b) {
				if (a.sortval < b.sortval) {
					return -1;
				} else if (a.sortval > b.sortval) {
					return 1;
				} else {
					return 0;
				}
			});


			return groups;
		},
		task_count() {
			return this.tasks.length;
		}
	},
	components: {
		task_item
	},
	created() {
	},
	methods: {
		perform_search(new_search) {
			// We need to find out how to cancel any already running search...

			let self = this; // make sure we can access this inside of our promisses
			this.loading = true;

			// it is possible for the user to execute a new search while the previous one is still running
			// this allows us to ignore those results.
			this.iteration += 1;
			let search_iteration = this.iteration

			// copy our search
			this.search = {... new_search};

			// build our url parameters
			let params = new Array();
			params.push("assign_mode=" + self.search.assign_mode);
			params.push("date_mode=" + self.search.date_mode);
			if (self.search.date_mode == 2) {
				if (self.search.start_date != '') params.push("start_date=" + encodeURIComponent(self.search.start_date));
				if (self.search.end_date != '') params.push("end_date=" + encodeURIComponent(self.search.end_date));
			}
			params.push("statusses=" + self.search.statusses);

			// build our url, we have to add url escaping here!
			let url = "/api/tasks";
			if (params.length > 0) {
				url+= "?" + params.join('&');
			}

			// console.log(url);

			// look into escaping our url thingies
			axios
				.get(url, {
					headers: {
						"Authorization": "Bearer " + self.$store.state.token,
						"Accept": "application/json"
					}
				})
				.then(function(d) {
					if (search_iteration == self.iteration) {
						// this is the result of the last search we've started, lets process it.
						let json = d.data;

						// For some reason axios isn't always converting our data
						if ((typeof json) == "string") {
							json = JSON.parse(json);
						}

						if (json.status == "OK") {
							const compare_arr = JSON.parse(JSON.stringify(json.data));
							compare_arr.forEach(d => {
								if (d.start_time.length !== 0) {
									const time_str = moment(d.start_time, "hh:mmA").format();
									const time = new Date(time_str).getTime();
									d['time_compare'] = time;
								} else {
									d['time_compare'] = 0;
								}
							});

							const compare_arr_A = compare_arr.filter(c => { return c.time_compare !== 0 });
							const compare_arr_B = compare_arr.filter(c => { return c.time_compare === 0 });

							compare_arr_A.sort((a,b) => { return a.time_compare - b.time_compare });					
							compare_arr_B.sort((a,b) => { return a.id - b.id });	
						
							const task_res = [...compare_arr_A, ...compare_arr_B];

							self.tasks = task_res;
							self.errormsg = '';
						} else {
							self.errormsg = json.reason;
						}
					} else {
						// this is the result for an older search we've started, we can ignore it
						console.log("Received result set for previous search - ignored")
					}
				})
				.catch(function(e) {
					if (search_iteration == self.iteration) {
						// this is the error for the last search we've started, lets show it.
						self.errormsg = e.message;
					} else {
						// this is an error for an older search that was stil running, we can ignore it
						console.log("Received error for previous search - ignored")
					}
					console.log(e);
				})
				.finally(function() {
					if (search_iteration == self.iteration) {
						self.loading = false;

						self.$emit('content_changed');
					} else {
						// this was the result or error for a search started before the last search we did
						// we can safely ignore it. If the last search is still going loading is still true
						// if the latest search has already finished it is already being displayed and loading is already false.
					}
				});	
		},
		filtered_tasks(key) {
			let tasks = [];

			if (key == '') {
				if (this.search.group_mode == 0) {
					tasks = this.tasks;
				}
			} else if (this.search.group_mode == 1) {
				// by day
				this.tasks.forEach(function(task) {
					if (task.date_fmt == key) {
						tasks.push(task);
					};
				});
			} else if (this.search.group_mode == 2) {
				// by client
				this.tasks.forEach(function(task) {
					if (task.client.id == key) {
						tasks.push(task);
					};
				});
			} else if (this.search.group_mode == 3) {
				// by job
				this.tasks.forEach(function(task) {
					if (task.job.id == key) {
						tasks.push(task);
					};
				});
			} else if (this.search.group_mode == 4) {
				// by status
				this.tasks.forEach(function(task) {
					if (task.status.id == key) {
						tasks.push(task);
					};
				});
			}

			/*
			// TODO make sort setable!
			tasks.sort(function(a, b) {
				if (a.date < b.date) {
					return -1;
				} else {
					return 1;
				}
			});
*/

			return tasks;
		},
		clear_results() {
			this.tasks = [];
		},
		open_task(task_id) {
			this.$emit('open_task', task_id);
		},
		stop_recording() {
			// forward to our parent
			this.$emit('stop_recording');
		}
	},
}
</script>
